export const BASE_URL = '/facility';
export const LOGIN_ROUTE_PATH = BASE_URL + '/login';
export const FACILITY_FORGOT_PASSWORD_ROUTE_PATH =
  BASE_URL + '/forgot-password';
export const FACILITY_RESET_PASSWORD_ROUTE_PATH = BASE_URL + '/reset-password';
export const TWO_FACTOR_AUTHENTICATION_ROUTE_PATH = BASE_URL + '/2fa';
export const FACILITY_ACCESS_DENIED_ROUTE_PATH = BASE_URL + '/access-denied';
export const FACILITY_LINK_EXPIRE_ROUTE_PATH = BASE_URL + '/link-expire';
export const FACILITY_CONSULT_REQUEST_DASHBOARD_ROUTE_PATH =
  BASE_URL + '/request';
export const CASEMANGER_CONSULT_REQUEST_DASHBOARD_ROUTE_PATH =
  BASE_URL + '/consults';
export const CONSULT_MORE_DETAILS_ROUTE_PATH = BASE_URL + '/more-details';
export const CONSULT_WAITING_SCREEN_ROUTE_PATH = BASE_URL + '/waiting-room';
export const FACILITY_CONSULT_CREATE_DASHBOARD_ROUTE_PATH =
  BASE_URL + '/create';

export const RE_SUBMIT_OR_CANCEL_CONSULT_ROUTE_PATH = BASE_URL + '/re-submit';
